import React from 'react';

function Contact() {
  return(
    <div className="home">
      <h1>Contact</h1>
      <p>Page is still in progress so if you are watching this page you probably know how to contact me. Have fun!</p>
    </div>
  );
}

export default Contact;
